import script from "./PriorHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PriorHeader.vue?vue&type=script&setup=true&lang=js"

import "./PriorHeader.vue?vue&type=style&index=0&id=61354638&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61354638"]])

export default __exports__